import React, { useState, useEffect, useRef } from "react";
import createDispatch from "./utils/createDispatch";
import { Context } from "./store";
export default function Provider(_ref) {
  var store = _ref.store,
      children = _ref.children;
  var reducer = store.reducer,
      initialState = store.initialState,
      middlewares = store.middlewares,
      onload = store.onload;
  var storeContext = storeHooks(reducer, initialState, middlewares);
  useEffect(function () {
    onload && onload(storeContext);
  }, []);
  return React.createElement(Context.Provider, {
    value: storeContext
  }, children);
}

function storeHooks(reducer, initialState, middlewares) {
  var _useState = useState(function () {
    return initialState;
  }),
      state = _useState[0],
      setState = _useState[1];

  var stateProvider = useRef();
  stateProvider.current = state; // store the state reference

  var _useState2 = useState(function () {
    var storeAPI = {
      getState: function getState() {
        return stateProvider.current;
      },
      dispatch: function dispatch(action) {
        var nextState = reducer(stateProvider.current, action);

        if (nextState !== stateProvider.current) {
          stateProvider.current = nextState; // update the state reference

          setState(nextState);
        }

        return action;
      }
    };
    return createDispatch.apply(void 0, middlewares)(storeAPI);
  }),
      dispatch = _useState2[0];

  return {
    state: state,
    dispatch: dispatch
  };
}